import { Component } from '@angular/core';

@Component({
  selector: 'globot-not-available',
  templateUrl: './not-available.component.html',
  styleUrls: ['./not-available.component.scss'],
})
export class NotAvailableComponent {
  showPlansDialog: boolean = false;
}
